import { render, staticRenderFns } from "./khRegistrationAgreement.vue?vue&type=template&id=5c6884c4&scoped=true&"
import script from "./khRegistrationAgreement.vue?vue&type=script&lang=js&"
export * from "./khRegistrationAgreement.vue?vue&type=script&lang=js&"
import style0 from "./khRegistrationAgreement.vue?vue&type=style&index=0&id=5c6884c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6884c4",
  null
  
)

export default component.exports